import React from "react";

import "./style.scss";

const CustomTab = ({ tabOptions, setTabValue, tabValue, setTabDetails, children }) => {
    
    const handleSelectTab = (tab) => {
        
        setTabValue(tab?.payloadType)
        setTabDetails && setTabDetails(tab?.requiredFields)
    }
    
    return (
        <div className="tab-main-container">
            <div className="tab-header-container">
                {tabOptions?.tabs?.map((tab) => {
                    return (
                        <div className={`tab-header-contents ${tabValue === tab?.payloadType ? 'selected-tab' : 'unselected-tab'}`}
                            onClick={() => handleSelectTab(tab)}>{tab?.title}
                        </div>
                    )
                })}
            </div>
            <div className="tab-body-container">{children}</div>
        </div>
    )
}

export default CustomTab;